import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
// import { ResearchReportDetail } from './components/ResearchForm';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ThemeToggle } from './components/ThemeToggle';
import { AlertContainer } from './components/common/AlertContainer';
import PrivateRoute from './components/auth/PrivateRoute';
import { AuthProvider } from './contexts/AuthContext';
import trackingService from './services/tracking.service';
import ErrorHandler from './components/util/ErrorHandler';
// import { SurveyManager } from './components/survey';
import AIKeywordsLandingPage from './components/AIKeywordsLandingPage';
// import LandingPageKW from './components/LandingPage_KW';
// import LandingPage from './components/LandingPage';

// const ResearchForm = lazy(() =>
//   import('./components/ResearchForm').then((module) => ({ default: module.ResearchForm }))
// );
// const ResearchReportsList = lazy(() =>
//   import('./components/ResearchReportsList').then((module) => ({ default: module.ResearchReportsList }))
// );
// const ResearchReport = lazy(() => import('./components/ResearchReport'));
// const ResearchReportMindMap = lazy(() => import('./components/ResearchReportMindMap'));
// const ResearchReportFeatureTree = lazy(() => import('./components/ResearchReportFeatureTree'));
const LoginForm = lazy(() => import('./components/auth/LoginForm'));
const RegisterForm = lazy(() => import('./components/auth/RegisterForm'));
const ForgotPasswordForm = lazy(() => import('./components/auth/ForgotPasswordForm'));
const ResetPasswordForm = lazy(() => import('./components/auth/ResetPasswordForm'));
const ConfirmationPage = lazy(() => import('./components/auth/ConfirmationPage'));
const UserSettingsPage = lazy(() => import('./components/user/UserSettingsPage'));
const PaymentSuccessPage = lazy(() => import('./components/pricing/PaymentSuccessPage'));
const PaymentFailedPage = lazy(() => import('./components/pricing/PaymentFailedPage'));
const SubscriptionPage = lazy(() => import('./components/pricing/SubscriptionPage'));
const CheckoutPage = lazy(() => import('./components/pricing/CheckoutPage'));
const AdminDashboard = lazy(() => import('./components/admin/AdminDashboard'));
const MarketingDashboardPage = lazy(() => import('./components/admin/MarketingDashboardPage'));
const TrendsPage = lazy(() => import('./components/trends/TrendsPage'));
const CombinedKeywordDetailsPage = lazy(() => import('./components/trends/CombinedKeywordDetailsPage'));
// const ProjectsPage = lazy(() => import('./components/user/ProjectsPage'));
// const MockupPage = lazy(() => import('./components/mockup/MockupPage'));
const RealAiKeywordsPage = lazy(() => import('./components/RealAiKeywordsPage'));
const QueriesPage = lazy(() => import('./components/QueriesPage'));
const AIAppPricingPage = lazy(() => import('./components/pricing/AIAppPricingPage'));
const ShowcasePage = lazy(() => import('./components/ShowcasePage'));
const ShowcasePage2 = lazy(() => import('./components/ShowcasePage2'));
const PageTestLandingPage = lazy(() => import('./components/PageTestLandingPage'));

const AppLayout = () => {
  const location = useLocation();
  const isAiKeywordsRoute = location.pathname.startsWith('/ai-keywords');
  const isStandaloneShowcaseRoute = location.pathname === '/' || location.pathname.startsWith('/showcase') || location.pathname.startsWith('/engine');
  const mainClassName = isAiKeywordsRoute
    ? 'flex-grow py-8'
    : isStandaloneShowcaseRoute
      ? 'flex-grow'
      : 'flex-grow container mx-auto px-4 py-8';

  return (
    <ErrorHandler>
      <div className="flex flex-col min-h-screen">
        {!isStandaloneShowcaseRoute && (
          <Navbar>
            <ThemeToggle />
          </Navbar>
        )}
        <main className={mainClassName}>
          {/* <SurveyManager> */}
            <Suspense fallback={null}>
              <Routes>
                {/* <Route path="/" element={<ShowcasePage />} /> */}
                <Route path="/" element={<PageTestLandingPage />} />
                {/* <Route path="/lp1" element={<LandingPageKW />} /> */}
                {/* <Route path="/lp2" element={<LandingPage />} /> */}
                {/* <Route path="/lp3" element={<AIKeywordsLandingPage />} /> */}
                <Route path="/showcase" element={<ShowcasePage2 />} />
                <Route path="/engine" element={<PageTestLandingPage />} />
                <Route path="/engine/:pageId" element={<PageTestLandingPage />} />
                {/* <Route path="/idea_scout" element={<IdeaScoutLandingPage />} /> */}
                <Route path="/pricing" element={<AIAppPricingPage />} />
                <Route path="/payment/success" element={<PaymentSuccessPage />} />
                <Route path="/payment/failed" element={<PaymentFailedPage />} />
                <Route path="/login" element={<LoginForm />} />
                <Route path="/register" element={<RegisterForm />} />
                <Route path="/forgot-password" element={<ForgotPasswordForm />} />
                <Route path="/reset-password" element={<ResetPasswordForm />} />
                <Route path="/confirm-email" element={<ConfirmationPage />} />

                {/* Preview routes - no authentication required - use existing components */}
                {/* <Route path="/preview/reports" element={<ResearchReportsList />} />
                <Route path="/preview/reports/:id" element={<ResearchReport />} /> */}

                {/* Admin routes - requires admin access */}
                <Route
                  path="/admin"
                  element={
                    <PrivateRoute>
                      <AdminDashboard />
                    </PrivateRoute>
                  }
                />
                <Route path="/marketing-dashboard" element={<MarketingDashboardPage />} />

                <Route
                  path="/subscription"
                  element={
                    <PrivateRoute>
                      <SubscriptionPage />
                    </PrivateRoute>
                  }
                />
                {/* <Route
                  path="/new_research"
                  element={
                    <PrivateRoute>
                      <ResearchForm />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/reports"
                  element={
                    <PrivateRoute>
                      <ResearchReportsList />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/reports/:id"
                  element={
                    <PrivateRoute>
                      <ResearchReport />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/reports/mindmap/:id"
                  element={
                    <PrivateRoute>
                      <ResearchReportMindMap />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/reports/featuretree/:id"
                  element={
                    <PrivateRoute>
                      <ResearchReportFeatureTree />
                    </PrivateRoute>
                  }
                /> */}
                <Route
                  path="/account/settings"
                  element={
                    <PrivateRoute>
                      <UserSettingsPage />
                    </PrivateRoute>
                  }
                />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/keywords" element={<TrendsPage />} />
                <Route path="/keywords/:keywordName" element={<TrendsPage />} />
                <Route path="/keywords/combined/:keywordName" element={<CombinedKeywordDetailsPage />} />
                {/* <Route path="/user/projects" element={<ProjectsPage />} />
                <Route path="/mockup" element={<MockupPage />} /> */}
                <Route path="/ai-keywords/landing" element={<AIKeywordsLandingPage />} />
                <Route path="/ai-keywords/*" element={<RealAiKeywordsPage />} />
                <Route path="/ai-keywords/researches/:researchId/queries" element={<QueriesPage />} />
              </Routes>
            </Suspense>
          {/* </SurveyManager> */}
        </main>
        {!isStandaloneShowcaseRoute && <Footer />}
        <AlertContainer />

        {/* Floating Chat - Available on all pages except report pages */}
        {/* <ConditionalFloatingChat /> */}
      </div>
    </ErrorHandler>
  );
};

export const App = () => {

  useEffect(() => {
    trackingService.initializeTracking();
  }, []);

  return (
      <Provider store={store}>
        <AuthProvider>
          <Router>
            <AppLayout />
          </Router>
        </AuthProvider>
      </Provider>
  );
};

export default App; 
